import type { FC } from 'react';
import type { BoxProps, Theme } from '@mui/material';
import React, { useState } from 'react';
import { pdfjs, Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import { Box, Button, CircularProgress, Typography, useMediaQuery } from '@mui/material';
import './pdf.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface ProgramProps extends BoxProps {
  src: string;
}

const Program: FC<ProgramProps> = (props) => {
  const { src, ...other } = props;
  const [page, setPage] = useState<number>(1);
  const [numPages, setNumPages] = useState<number | null>(null);
  const [progress, setProgress] = useState<number>(0);

  const lgDown = useMediaQuery((theme: Theme) => theme.breakpoints.down(theme.breakpoints.values.lg));

  const handleDocumentLoad = ({ numPages }) => {
    setNumPages(numPages);
  };

  const handleLoadProgress = ({ loaded, total }) => {
    setProgress((loaded / total) * 100);
  };

  const nextPage = () => {
    setPage((prev) => prev + 1);
  };

  const prevPage = () => {
    setPage((prev) => prev - 1);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
      {...other}
    >
      <Box sx={{ minHeight: lgDown ? 700 : 930}}>
        <Document
          file={src}
          onLoadProgress={handleLoadProgress}
          onLoadSuccess={handleDocumentLoad}
          loading={<CircularProgress value={progress} sx={{ mt: '350px' }} />}
        >
          <Page
            key={page}
            width={lgDown ? 900 : 1200}
            pageNumber={page}
            loading={<CircularProgress sx={{ mt: '350px' }} />}
          />
        </Document>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Button onClick={prevPage} disabled={page <= 1}>Previous</Button>
        <Typography variant="button" color="textSecondary">{`${page} / ${numPages ?? 1}`}</Typography>
        <Button onClick={nextPage} disabled={page >= numPages}>Next</Button>
      </Box>
    </Box>
  );
};

export default Program;
